export default "__VITE_ASSET__DEqfRhWg__"